<template>
  <div class="pageCenter">
    <slot></slot>
  </div>
</template>

<script>

  export default {
    name: 'PageCenter',
    props: [],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style>
  .pageCenter {
    display: flex;
    align-content: center;
    height: 100%;
    flex-direction: column;
    width: 100%;
    justify-content: center;
  }

  .pageCenter div {
    margin: 0 auto;
  }

</style>
